/**
 * @fileoverview Model for the Apple Country Infos for a given account.
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */

import {AppleCountryInfo} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/applecountryinfo';

export class GetAppleCountryInfosResponse {
  /**
   * @param {{
   *  appleCountryInfos: !Array<AppleCountryInfo>,
   * }} params
   */
  constructor(params) {
    /** @type {!Array<AppleCountryInfo>} */
    this.appleCountryInfos = params.appleCountryInfos;
  }

  /**
   * @param {!GetAppleCountryInfosResponseJson} json
   * @return {!GetAppleCountryInfosResponse}
   */
  static fromJSON(json) {
    return new GetAppleCountryInfosResponse({
      appleCountryInfos: json['appleCountryInfos'].map(AppleCountryInfo.fromJSON),
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  appleCountryInfos: !Array<AppleCountryInfo>,
 * }}
 */
export let GetAppleCountryInfosResponseJson;
